/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, OnInit} from '@angular/core';
import {AnalyticsService} from './@core/utils/analytics.service';
import {TranslateHelper} from './@theme/services/translate-helper.service';
import {environment} from '../environments/environment';
import {CookieService} from 'ngx-cookie-service';
import {versionInfo} from './version-info';
import {NGXLogger} from 'ngx-logger';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(private analytics: AnalyticsService,
              private translateHelper: TranslateHelper,
              private cookieService: CookieService,
              private logger: NGXLogger) {
    this.translateHelper.useLanguage(environment.language);
    // this.cookieService.deleteAll('');
    // this.cookieService.set('locale', environment.language, 1, '/');
    localStorage.setItem('locale', environment.language);
    this.logger.debug('locale = ', environment.language);
    this.logger.debug('versionInfo = ', versionInfo);
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
  }
}
